export default {
  setItems: ({ commit }, items) => {
    commit('SET_ITEMS', items)
  },
  setUser: ({ commit }, user) => {
    commit('SET_USER', user)
  },
  setUserClone: ({ commit }, user) => {
    commit('SET_USER_CLONE', user)
  },
  updateChangedUserProperties: ({ commit }, params) => {
    commit('UPDATE_CHANGED_USER_PROPERTIES', params)
  },
  resetChangedUserProperties: ({ commit }) => {
    commit('RESET_CHANGED_USER_PROPERTIES')
  },

  setPersonalInboxData: ({ commit }, { id, missedCallsSettings }) => {
    commit('SET_PERSONAL_INBOX_DATA', { id, missedCallsSettings })
  },

  updateChangedPersonalInboxProperties: ({ commit }, params) => {
    commit('UPDATE_CHANGED_PERSONAL_INBOX_PROPERTIES', params)
  },

  resetChangedPersonalInboxProperties: ({ commit }) => {
    commit('RESET_CHANGED_PERSONAL_INBOX_PROPERTIES')
  },

  syncPersonalInboxCloneAfterSave: ({ commit }) => {
    commit('SYNC_PERSONAL_INBOX_CLONE_AFTER_SAVE')
  },

  setFormValidity: ({ commit }, isValid) => {
    commit('SET_FORM_VALIDITY', isValid)
  }
}
